import { useUnit } from 'effector-react'
import { ui } from '!/skin'
import { type JSX } from 'react'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { Skeleton } from '@/ui/components/Skeleton'
import { DynamicRows } from './rows'

DynamicPage.displayName = 'DynamicPage'
export function DynamicPage(): JSX.Element {
  const [rows, isRowsLoading, isBannersLoading] = useUnit([
    dynamicModuleModel.$viewRows,
    dynamicModuleModel.$isRowsLoading,
    dynamicModuleModel.$isBannersLoading,
  ])

  const isContentLoading = (!rows.length && isRowsLoading) || isBannersLoading

  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={isContentLoading}>
        <DynamicRows />
      </Skeleton>
    </ui.PageWrapper>
  )
}
